/// <reference path="app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    angular
        .module('app', [
        'app.Components',
        'app.Dashboard',
        'app.Directives',
        'app.Modals',
        'app.Reporting',
        'app.Services',
        'app.Testing',
        'angular-uuid',
        'ngCookies',
        'ngRoute',
        'ngSanitize',
        'ngScrollTo',
        'daterangepicker',
        'mwl.confirm',
        'pascalprecht.translate',
        'ui.bootstrap',
        'ui.sortable',
        'ui.select',
        'btorfs.multiselect',
        'deploy' // This module is defined in the app.config then redefined when deploying.  Used to replace the api url per deployment environment.
    ]);
    angular.module('app.Components', []);
    angular.module('app.Dashboard', []);
    angular.module('app.Directives', []);
    angular.module('app.Modals', []);
    angular.module('app.Reporting', []);
    angular.module('app.Services', []);
    angular.module('app.Testing', []);
    angular.module('app').run([
        '$route', function ($route) {
            $route.reload();
        }
    ]);
})(app || (app = {}));
